<div class="loader" [class.loader--overlay]="overlay()" [attr.data-size]="size()">
  <div class="spinner"></div>
  @if (message()) {
    <p class="loader__message">{{ message() }}</p>
  }
</div>